// Single source of truth for fee source labels across admin-webapp.
// TODO(i18n): Replace hard-coded labels with translation keys when i18n is introduced here.
export const FEE_SOURCE_LABELS = {
  venue: 'Venue custom',
  'tenant-contract': 'Legacy Contract',
  'plan-feature': 'Piano base',
  'plan-feature-override': 'Offerta commerciale',
  'tenant-legacy-terms': 'Condizioni legacy',
  global: 'Global default',
  'env-emergency': 'Fallback ENV'
};

export const getFeeSourceLabel = (source, fallback = 'sconosciuta') => {
  if (!source) return fallback;
  return FEE_SOURCE_LABELS[source] || source;
};
